module.exports = __webpack_public_path__ + "a17c8266df627d71195435f386885fed.pdf";